import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  PiHouseSimpleFill,
  PiShoppingCartSimpleFill,
  PiChatCircleTextFill,
  PiUserCircleFill,
} from "react-icons/pi";

function UserNavBar() {
  const [activeLink, setActiveLink] = useState("Home");
  const [isVisible, setIsVisible] = useState(true);
  const location = useLocation();

  useEffect(() => {
    // Function to check if navbar should be hidden
    const checkVisibility = () => {
      const hideNavbar = document.body.classList.contains("hide-navbar");
      // Check for both group chat and direct chat routes
      const isChatRoute =
        location.pathname.includes("/group-chats/") ||
        location.pathname.includes("/chats/");
      setIsVisible(!hideNavbar && !isChatRoute);
    };

    // Check initially
    checkVisibility();

    // Set up a mutation observer to watch for class changes on body
    const observer = new MutationObserver(checkVisibility);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });

    // Cleanup
    return () => observer.disconnect();
  }, [location.pathname]);

  const navItems = [
    {
      icon: <PiHouseSimpleFill />,
      label: "Home",
    },
    {
      icon: <PiShoppingCartSimpleFill />,
      label: "MarketPlace",
    },
    {
      icon: <PiChatCircleTextFill />,
      label: "Chat",
    },
    {
      icon: <PiUserCircleFill />,
      label: "Profile",
    },
  ];

  const activeLinkStyle =
    "text-green-700 bg-green-100 rounded-lg transition-all duration-200 hover:bg-green-50";
  const inactiveLinkStyle =
    "text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-all duration-200";
  const navigate = useNavigate();

  const handleClick = (link) => {
    setActiveLink(link);
    navigate(`/${link.toLowerCase()}`);
  };

  if (!isVisible) return null;

  return (
    <div
      className="flex items-center justify-center gap-8 bg-white shadow-lg p-2 rounded-t-xl pb-6 mx-auto max-w-[450px] w-screen nav border-t fixed bottom-0 left-0 right-0 z-10"
      style={{ marginBottom: 0 }}
    >
      {navItems.map((item, index) => (
        <div
          key={index}
          className={`flex flex-col items-center p-3 cursor-pointer
          ${activeLink === item.label ? activeLinkStyle : inactiveLinkStyle}
            `}
          onClick={() => handleClick(item.label)}
        >
          <div className="text-2xl mb-1">{item.icon}</div>
          <div className="text-xs font-medium">{item.label}</div>
        </div>
      ))}
    </div>
  );
}

export default UserNavBar;